import React from 'react';
import HotelCategory from '../detail/preview/HotelCategory';
import { Icon } from '@iconify/react';
import { useZitoneoHotelPresentation } from '../../contexts/ZitoneoContentContext';
import LoadingPlaceholder from '../../../../muiComponents/LoadingPlaceholder';
import Tag from '../../../../muiComponents/Tag';
import {
    STATUS_TAG_COLORS,
    STATUS_KEYS,
} from '../../utils/zitoneoServicesUtils';

const HotelHeader = () => {
    const { hotel, isLoading } = useZitoneoHotelPresentation();
    const {
        hotelOwner,
        category,
        categoryKey,
        name,
        address,
        publishStatus,
        publishStatusKey,
    } = hotel;
    const publishStatusColor =
        STATUS_TAG_COLORS[publishStatusKey as keyof typeof STATUS_TAG_COLORS];

    return (
        <div className='hotel-presentation__header'>
            <div className='hotel-presentation__header-content'>
                <div className='flex flex-align-center gap-10'>
                    {isLoading ? (
                        <LoadingPlaceholder
                            variant='text'
                            width={150}
                            height={24}
                            aria-hidden='true'
                        />
                    ) : (
                        <h5 className='hotel-presentation__hotel-owner'>
                            {hotelOwner}
                        </h5>
                    )}
                    <span
                        className='hotel-presentation__separator'
                        aria-hidden='true'
                    >
                        ·
                    </span>
                    {isLoading ? (
                        <LoadingPlaceholder
                            variant='rounded'
                            width={100}
                            height={24}
                            aria-hidden='true'
                        />
                    ) : (
                        <HotelCategory
                            category={category}
                            categoryKey={categoryKey}
                        />
                    )}
                </div>
                {isLoading ? (
                    <LoadingPlaceholder
                        variant='text'
                        width='45%'
                        height={56}
                        aria-hidden='true'
                    />
                ) : (
                    <h1 className='hotel-presentation__hotel-name'>{name}</h1>
                )}
                <div className='flex flex-align-center gap-5'>
                    {isLoading ? (
                        <LoadingPlaceholder
                            variant='text'
                            width={220}
                            height={24}
                            aria-hidden='true'
                        />
                    ) : (
                        <>
                            <Icon
                                icon='mdi:location-on-outline'
                                className='hotel-presentation__address-icon'
                            />
                            <p className='hotel-presentation__address'>
                                {address || '----'}
                            </p>
                        </>
                    )}
                </div>
            </div>
            <div className='hotel-presentation__header-actions'>
                {isLoading ? (
                    <LoadingPlaceholder
                        variant='rounded'
                        width={100}
                        height={28}
                        aria-hidden='true'
                    />
                ) : publishStatusKey !== STATUS_KEYS.NOT_STARTED ? (
                    <Tag
                        variant='outlined'
                        text={publishStatus}
                        color={publishStatusColor}
                        size='large'
                    />
                ) : null}
            </div>
        </div>
    );
};

export default HotelHeader;
